import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login-area pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Log In Here!"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-12" }
const _hoisted_9 = { class: "form-inner mb-25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email*", -1)
const _hoisted_11 = { class: "input-area" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/email-2.svg",
  alt: ""
}, null, -1)
const _hoisted_13 = { class: "col-lg-12" }
const _hoisted_14 = { class: "form-inner" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Password*", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-eye-slash",
  id: "togglePassword"
}, null, -1)
const _hoisted_17 = { class: "col-lg-12" }
const _hoisted_18 = { class: "form-agreement form-inner d-flex justify-content-between flex-wrap" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "checkbox",
    id: "html"
  }),
  /*#__PURE__*/_createElementVNode("label", { for: "html" }, "Remember Me")
], -1)
const _hoisted_20 = { class: "col-lg-12" }
const _hoisted_21 = { class: "form-inner" }
const _hoisted_22 = {
  key: 1,
  class: "primry-btn-2",
  type: "button"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white mt-0",
  style: {"font-size":"20px"}
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createTextVNode("Don’t have an account?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_25 = { class: "col-lg-6" }
const _hoisted_26 = { class: "col-lg-6 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.email) = $event)),
                          type: "email",
                          id: "email",
                          name: "email",
                          placeholder: "info@example.com"
                        }, null, 512), [
                          [_vModelText, _ctx.user.email]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.password) = $event)),
                        type: "password",
                        name: "password",
                        id: "password",
                        placeholder: "Password"
                      }, null, 512), [
                        [_vModelText, _ctx.user.password]
                      ]),
                      _hoisted_16
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_router_link, {
                        class: _normalizeClass(_ctx.forgot-_ctx.pass),
                        to: {name: 'forgot-password'}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Forgot Password?")
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      (!_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
                            class: "primry-btn-2",
                            type: "button"
                          }, "LogIn"))
                        : (_openBlock(), _createElementBlock("button", _hoisted_22, [
                            _createTextVNode(" Processing... "),
                            _hoisted_23
                          ]))
                    ])
                  ]),
                  _hoisted_24,
                  _createElementVNode("small", _hoisted_25, [
                    _createVNode(_component_router_link, { to: {name: 'job-seeker-register'} }, {
                      default: _withCtx(() => [
                        _createTextVNode("Job Seeker Sign Up")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("small", _hoisted_26, [
                    _createVNode(_component_router_link, { to: {name: 'employer-register'} }, {
                      default: _withCtx(() => [
                        _createTextVNode("Company Sign Up")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}